import request from '@/util/request'

// 获取首页展示教师列表（公开接口）
export function getFeaturedList() {
  return request({
    url: '/featured/list',
    method: 'get',
  })
}

// 添加教师到首页展示
export function addFeatured(userId) {
  return request({
    url: `/featured/add?userId=${userId}`,
    method: 'post',
  })
}

// 移除首页展示教师
export function removeFeatured(id) {
  return request({
    url: `/featured/remove/${id}`,
    method: 'delete',
  })
}

// 更新排序
export function reorderFeatured(ids) {
  return request({
    url: '/featured/reorder',
    method: 'put',
    data: { ids },
  })
}
